export enum RolloverState {
  Open = 'open',
  InProgress = 'in_progress',
  Locked = 'locked',
}
